import React from 'react'
import PropTypes from 'prop-types'

import {
  DefaultAvatarComponent,
  CommentReactionFormatText,
} from '../../../../components'

import './QuestionPanelItemComponent.scss'

const QuestionPanelItemComponent = ({ item }) => {
  return (
    <div className="question-panel-item-component">
      <div className="identity">
        <DefaultAvatarComponent
          identifier={item.truncated_name}
          width={32}
          height={32}
        />
        <div className="identity-content">
          <div className="name">{item.full_name}</div>
          <div className="email">{item.email}</div>
        </div>
      </div>
      <div className="comment-body">
        <CommentReactionFormatText>
          {item.content_text}
        </CommentReactionFormatText>
      </div>
    </div>
  )
}

QuestionPanelItemComponent.propTypes = {
  item: PropTypes.object,
}

export default QuestionPanelItemComponent
